<div
  class="router-progress-bar"
  [class._hide]="!isRouterLoading"
  [style.opacity]="isRouterLoading ? 1 : 0"
>
  <p-progressBar
    [value]="routerLoadingValue"
    [style]="{ height: '6px' }"
    [showValue]="false"
  />
</div>
<p-confirmdialog [style]="{ marginTop: '6rem' }" />
<p-toast />

<!-- <ngx-loading-bar ></ngx-loading-bar> -->
<router-outlet />
